import crypto from "node:crypto";

/**
 * 生成百家号话题html
 * @param topic
 * @param id
 * @param sv_small_images
 */
export const generateTopicHtml = function (topic: string, id?: string, sv_small_images?: {
    http: string,
    https: string
}) {
    const generateUid = function () {
        const e = () => Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
        return e() + e() + e() + e() + e() + e() + e() + e();
    };
    const topicBase = function (topic: string, id?: string, sv_small_images?: { http: string, https: string }) {
        const t = function (r: any) {
            let n = [];
            let e = 0;
            for (; e < 256; ++e)
                n[e] = (e + 256).toString(16).substr(1);
            let o = 0;
            return [
                n[r[o++]], n[r[o++]], n[r[o++]], n[r[o++]], "-",
                n[r[o++]], n[r[o++]], "-",
                n[r[o++]], n[r[o++]], "-",
                n[r[o++]], n[r[o++]], "-",
                n[r[o++]], n[r[o++]], n[r[o++]], n[r[o++]], n[r[o++]], n[r[o++]]
            ].join("");
        };
        const s = crypto.randomBytes(16);
        // @ts-ignore
        (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128);
        return {
            id: id || t(s),
            sv_small_images: sv_small_images || "",
            title: topic.replace(/[^\u4E00-\u9FA5a-zA-Z0-9]/g, ""),
            isCreate: 1
        };
    };

    const n = id ? topicBase(topic, id, sv_small_images) : topicBase(topic);
    const topicAttr = {
        style: "border:none;display:inline-block;color:#3E5599;text-decoration:none;font-style:normal;",
        href: `https://m.baidu.com/s?word=%23${n.title}%23&topic_id=${n.id}&sa=edit&sfrom=1023524a&append=1&newwindow=0&upqrade=1`.replace(/&/g, "&amp;"),
        target: "_blank",
        // @ts-ignore
        "data-bjh-cover": "".concat(n.sv_small_images && (n.sv_small_images.https || n.sv_small_images.http)),
        "data-bjh-src": `https://m.baidu.com/s?word=%23${n.title}%23&topic_id=${n.id}&sa=edit&sfrom=1023524a&append=1&newwindow=0&upqrade=1`.replace(/&/g, "&amp;"),
        "data-bjh-box": "topic",
        "data-bjh-title": n.title,
        "data-bjh-id": id || n.id,
        "data-bjh-type": "topic",
        contenteditable: "false",
        "data-ignore-remove-style": "1",
        "data-bjh-create": id ? "0" : "1",
        "data-bjh-adinspiration": "0",
        "data-diagnose-id": generateUid()
    };

    const attrStr = Object.entries(topicAttr)
        .map(([key, val]) => `${key}="${val}"`)
        .join(" ");

    return `<p><span data-diagnose-id=${generateUid()}></span><a ${attrStr}>#${n.title}#</a></p>`;
};